import React, { createContext, useContext, useMemo } from 'react';
import { DIMENSION_GROUPS, useGetDimensionGroup } from '@beef/ui-kit';
import { getHasBrowserWindowAPI } from "../../layouts/Header/utils";
var BreakpointContext = /*#__PURE__*/createContext({
  isMobile: false,
  isTablet: false,
  isDesktop: false
});
export var useBreakpointContext = function useBreakpointContext() {
  return useContext(BreakpointContext);
};
export var BreakpointProvider = function BreakpointProvider(_ref) {
  var isMobileDevice = _ref.isMobileDevice,
    children = _ref.children;
  var dimension = useGetDimensionGroup();
  var value = useMemo(function () {
    return {
      isDesktop: getHasBrowserWindowAPI() ? dimension === DIMENSION_GROUPS.desktop : !isMobileDevice,
      isTablet: getHasBrowserWindowAPI() ? dimension === DIMENSION_GROUPS.tablet : isMobileDevice,
      isMobile: getHasBrowserWindowAPI() ? dimension === DIMENSION_GROUPS.mobile : isMobileDevice
    };
  }, [isMobileDevice, dimension]);
  return /*#__PURE__*/React.createElement(BreakpointContext.Provider, {
    value: value
  }, children);
};